import './CardItemsWidget.scss'

export default function CardItemsWidget({ productList, values }) {

    return (
        <div className="card_items">
            {productList.map(item => {
                return (
                    <>
                        {item.value ? <p className={values.includes(item.value.toString()) ? 'active' : ''}>{item.label}</p> : <></>}
                    </>
                )
            })}
        </div>
    )
}